module.exports = __webpack_public_path__ + "static/img/qrcode-mini.31cb5be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode-mini.png
// module id = tsxt
// module chunks = 1